<template>
  <div class="">
    <b-tabs nav-class="sub-menu"
            content-class="pt-4"
            class="w-100">
      <b-tab active :title="$t('user_data')">
        <div class="row">
          <template v-for="(f, find) in options.fields">
            <div :key="'form-field-'+find"
                 v-if="f.form && !f.form.hidden && !(edit && f.unavailableonedit) && !(!edit && f.unavailableoncreate) && !(f.form.disabledForSelf && isSelf)"
                 :class="f.form && f.form.classes ? f.form.classes : 'col-12'">
              <VariableInput :field="f"
                             :object="object"
                             :edit="edit"
                             :selectModels="selectModels"/>
              <ValidationError :validationId="f.validation_id || f.id"/>
            </div>
          </template>
          <div class="col-12">
            <div class="row no-gutters align-items-center mb-2">
              <div class="col-auto form-label mb-0">
                {{ $t('salary_report') }}
              </div>
              <div class="col">
                <SwitchGroup class="ml-3 mb-0"
                             :label="object.see_others_salaries ? $t('see_all') : $t('see_only_yourself')"
                             v-model="object.see_others_salaries"/>
              </div>
            </div>

          </div>
          <div class="col-12" v-if="options.model === 'doctor'">
            <ServiceMultiSelect :label="$t('chairs')"
                                :dblclick="false"
                                model="chair"
                                title="chair_name"
                                :dbsearch="false"
                                :prepopulatedOptions="selectModels.chairs"
                                v-model="object.chairs"/>
          </div>
          <div class="col-12" v-if="options.model === 'doctor' && loaded && rights.includes('branches')">
            <ServiceMultiSelect :label="$t('branch')"
                                :dblclick="false"
                                model="branch"
                                title="title"
                                :dbsearch="false"
                                :prepopulatedOptions="selectModels.branch_id"
                                v-model="object.branches"/>
          </div>
          <div class="col-12">
            <FileGroup :label="$t('photo')"
                       :fid="`file-doctor-photo`"
                       :deletefile="true"
                       filetype="image"
                       v-model="object.image"/>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('login_and_password')"
             v-if="['assistant', 'doctor', 'administrator', 'curator', 'superadministrator'].includes(options.model)">
        <div class="row">
          <div class="col-md-12">
            <InputGroup type="text"
                        :label="$t('login')"
                        :key="`input-username-${object.lname}-${userNameKey}`"
                        ref="usernameRef"
                        :readonly="loginReadonly && !loginEditing"
                        :required="true"
                        @input="loginKeyup"
                        v-model="object.username">
              <a v-if="!loginEditing" @click="loginEditing = true" class="show-password"><EditSvg/></a>
            </InputGroup>
            <ValidationError validationId="username"/>
          </div>
          <template v-if="showPasswordFields">
            <div class="col-md-4">
              <InputGroup type="password"
                          autocomplete="current-password"
                          :label="$t('old_password')"
                          :required="true"
                          v-model="object.old_password"/>
              <ValidationError validationId="old_password"/>
            </div>
            <div class="col-md-4">
              <InputGroup type="password"
                          autocomplete="new-password"
                          :label="$t('new_password')"
                          :required="true"
                          v-model="object.password"/>
              <ValidationError validationId="password"/>
            </div>
            <div class="col-md-4">
              <InputGroup type="password"
                          autocomplete="new-password"
                          :label="$t('confirm_password')"
                          :required="true"
                          v-model="object.password_confirmation">
                <template #note>
                  <div class="text-danger small"
                       v-if="object.password && object.password_confirmation && object.password != object.password_confirmation">
                    {{ $t('password_does_not_match_confirmation') }}
                  </div>
                </template>
              </InputGroup>
              <ValidationError validationId="confirm_password"/>

            </div>
          </template>
        </div>

        <div v-if="showPasswordFields">
          <PasswordRequirementsChecklist :password="object.password"
                                         class="mb-3"/>
        </div>

        <div v-if="!showPasswordFields && edit" class="mb-3">
          <a v-if="object.email && !resetPasswordSent"
             class="text-underlined pointer"
             @click="resetPassword">{{ $t('reset_password') }}
          </a>
          <div v-if="object.email" class="small text-muted mt-2">
            {{ $t('reset_password_email_note') }}
          </div>
          <div v-else class="text-danger small">
            {{ $t('email_required_for_password_reset') }}
          </div>
          <div v-if="resetPasswordSent" class="text-success small mt-2">
            {{ $t('password_reset_link_sent') }}
          </div>
        </div>

        <div v-if="passwordValidUntil" class="small text-muted mt-2 mb-3">
          {{ $t('password_valid_until_note') }} {{ passwordValidUntil }}
        </div>

        <TwoFactorAuthenticationSettings :user="object"/>

<!--        <div v-if="showPasswordFields && object.password && object.email && rights.includes('password_send')">-->
<!--          <CheckboxGroup :label="$t('send_mail')"-->
<!--                         class="mt-4"-->
<!--                         :fid="`pass-check`"-->
<!--                         v-model="object.sendPassword"/>-->
<!--        </div>-->
      </b-tab>
      <b-tab :title="$t('functionality')"
             v-if="!['superadministrator', 'technic'].includes(options.model) && !isSelf">
        <SelectGroup :options="customRoles"
                     v-if="rights.includes('staff_roles') && customRoles && customRoles.length"
                     title="title"
                     :showlabel="true"
                     variant="white"
                     :label="$t('role')"
                     :info-hint="$t('user_will_assigned_rights_selected_for_that_role')"
                     v-model="object.custom_role_id"/>
        <StaffFunctionality v-if="object.userFunctions"
                            :selectModels="selectModels"
                            :object="object"/>
      </b-tab>
      <b-tab :title="$t('egisz')"
             v-if="rights.includes('egisz_view') && options.model === 'doctor'">
        <div class="row">
          <div class="col-md-6">
            <ServiceMultiSelect :label="$t('doctor_position')"
                                :onlyId="true"
                                :dblclick="false"
                                model="egiszDictionary"
                                title="title"
                                :multiple="false"
                                :dbsearch="false"
                                :prepopulatedOptions="selectModels.egisz_position"
                                v-model="object.egisz_position"/>
          </div>
          <div class="col-md-6">
            <ServiceMultiSelect :label="$t('doctor_specialty')"
                                :onlyId="true"
                                :dblclick="false"
                                model="egiszDictionary"
                                title="title"
                                :multiple="false"
                                :dbsearch="false"
                                :prepopulatedOptions="selectModels.egisz_specialty"
                                v-model="object.egisz_specialty"/>
          </div>
        </div>
      </b-tab>
      <b-tab title="FDoc" v-if="hasFdocRight && object.meta_data">
        <div class="row">
          <div class="col-md-6">
            <InputGroup type="text"
                        :label="$t('employee_login')"
                        v-model="object.meta_data.fdoc_login">
            </InputGroup>
            <ValidationError validationId="fdoc_login"/>
          </div>
          <div class="col-md-6">
            <InputGroup type="password"
                        autocomplete="new-password"
                        :label="$t('employee_password')"
                        v-model="object.meta_data.fdoc_password"/>
            <ValidationError validationId="fdoc_password"/>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('additional_info')"
             v-if="options.model === 'doctor' && object.meta_data">
        <AutosizeTextArea :label="$t('about_doctor')"
                          v-model="object.meta_data.about_doctor"
                          :placeholder="$t('about_doctor')"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script setup>

import FileGroup from "@/components/form/FileGroup"
// import CheckboxGroup from "@/components/form/CheckboxGroup"
import InputGroup from "@/components/form/InputGroup"
import ValidationError from "@/components/form/ValidationError"
import VariableInput from "@/components/form/VariableInput"
import ServiceMultiSelect from "@/components/form/ServiceMultiSelect"
import EditSvg from '@/assets/svg-vue/general/edit.svg'
import { useStore} from "vuex"
import { transliterate } from "@/services/translit.service"
import SelectGroup from "@/components/form/SelectGroup.vue"
import AutosizeTextArea from "@/components/form/AutosizeTextArea"
import StaffFunctionality from "@/components/parts/staff/StaffFunctionality.vue"
import {computed, nextTick, onMounted, ref, watch} from "vue"
import {copyObject} from "@/extensions/prototypes/prototypes"
import SwitchGroup from "@/components/form/SwitchGroup.vue"
import TwoFactorAuthenticationSettings from "@/components/parts/staff/TwoFactorAuthenticationSettings.vue"
import PasswordRequirementsChecklist from "@/components/parts/staff/PasswordRequirementsChecklist.vue"
import moment from "moment"
import { generateDefaultPassword } from "@/services/random.service"

const props = defineProps({
  object: {},
  selectModels: {
    type: Object
  },
  options: {}
})

const store = useStore()

const loaded = ref(false)
const userNameKey = ref(1)
const loginEditing = ref(false)
const usernameRef = ref()

const hasFdocRight = computed(() => rights.value.includes('fdoc'))
const clinic = computed(() => store.state.auth.clinic)
const user = computed(() => store.state.auth.user)
const rights = computed(() => store.state.auth.rights)
const superadmin = computed(() => store.state.auth.superadmin)
const model = computed(() => store.state.datatable.viewModel)
const doctorFunctions = computed(() => props.selectModels?.functions?.doctor_functions || [])
const customRoles = computed(() => props.selectModels?.functions?.custom_roles || [])
const edit = computed(() => !!props.object[props.options.primaryKey])
const lname = computed(() => props.object.lname)
const isSelf = computed(() => Number(props.object.id) === Number(user.value.id))
const loginReadonly = computed(() => {
  if(superadmin.value) return false
  return !!props.object.id
})
const isStaff = computed(() => ['superadministrator', 'administrator', 'doctor', 'curator', 'assistant'].includes(model.value))
const passwordRequirements = computed(() => store.state.auth.passwordRequirements)
const showPasswordFields = computed(() => isSelf.value)
const passwordValidUntil = computed(() => {
  if(!props.object.password_valid_until) return null
  return moment(props.object.password_valid_until).format('DD.MM.YYYY')
})

const resettingPassword = ref(false)
const resetPasswordSent = ref(false)

const resetPassword = async () => {
  if(resettingPassword.value) return
  resettingPassword.value = true
  resetPasswordSent.value = false
  try {
    await store.dispatch('sendStaffPasswordResetLink', {
      id: props.object.id,
      superadminClinicId: superadmin.value ? props.object.clinic_id : null,
    })
    resetPasswordSent.value = true
  } catch (error) {
    console.error('Reset password error:', error)
  } finally {
    resettingPassword.value = false
  }
}

onMounted(() => {
  props.object.userFunctions = copyObject(doctorFunctions.value)
  props.object.image = props.object.photo
  props.object.sendPassword = true
  if(isStaff.value && !props.object.meta_data) {
    props.object.meta_data = {}
  }
  if(!props.object.id && isStaff.value) {
    const defaultPassword = generateDefaultPassword(passwordRequirements.value)
    props.object.password = defaultPassword
    props.object.password_confirmation = defaultPassword
  }
  if(!props.object.branches || !props.object.branches.length) {
    const branchOptions = props.selectModels.branch_id || props.selectModels.branches
    props.object.branches = branchOptions.filter(b => b.id == props.object.branch_id)
  }
  loaded.value = true
})

const loginKeyup = async () => {
  await nextTick()
  const clinicId = clinic.value.id.toString()
  if(!props.object.username.startsWith(clinicId)) {
    if(props.object.username.length < clinicId.length) {
      props.object.username = `${clinicId}`
      userNameKey.value++
      await nextTick()
      usernameRef.value?.focus()
    } else {
      props.object.username = `${clinicId}${props.object.username}`
    }
  }
}

watch(lname, (val) => {
  if(!props.object.id && isStaff.value) {
    props.object.username = clinic.value.id.toString() + transliterate(val)
  }
})
</script>

<style scoped>
.info-svg {
  cursor: help;
}
</style>
